export const GARAGE_QUERY = 'garage';

export const GET_GARAGE_QUERY = 'get-garage';
export const GARAGE_HOURS_OPEN_QUERY = 'get-garage-hours-open';

export const GARAGE_UPDATE_GARAGE_HOURS = 'update-garage-hours';
export const GARAGE_ADD_GARAGE_HOURS = 'add-garage-hours';
export const GARAGE_DELETE_GARAGE_HOURS = 'delete-garage-hours';
